import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/prescription-dashboard`;
const endpoints = {
    summary: () => `${RESOURCE_ENDPOINT}/summary`,
};

export default class PrescriptionDashboardApi {
    public summary = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.summary();
        return HttpService.get(url, params, headers);
    };
}
